export default __webpack_public_path__ + "static/media/content-deco-5.3314ec3d.webp";